import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import {
    IconAlertTriangleFilled
} from "@tabler/icons-react";
import axios from 'axios';
import Page from "../../Components/Page";
import Sidebar from '../../Components/Sidebar';
import { addSliderData, deleteSliderData, editSliderData, getSliderData,updateSliderPriority } from '../../controllers/sliderManagement.controller';
import toast from 'react-hot-toast';
import Button from '../../Components/Button';

const SliderManagement = () => {

    const [image, setImage] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);

    const [data, setData] = useState([])

    const addCaptionRef = useRef();
    const editCaptionRef = useRef();

    const fetchTableData = async () => {
        const res = await getSliderData()
        //console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const tableData = apiData?.map((d) => ({
                id: d.id,
                image: d.image_url,
                caption: d.caption,
                priority: d.slider_order,
            }))
            setData(tableData)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //         setSelectedFile(file)
    //     } else setSelectedFile(null)

    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        handleFileSelected(file);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileSelected(file);
    };


    const handleFileSelected = (file) => {
        if (file) {
            if (file.size > 1024 * 5120) {  // 1MB limit
                toast.error("File size exceeds 5MB.");
                return;
            }
            setImage(URL.createObjectURL(file));
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const removeImage = () => {
        setImage(null);
        setSelectedFile(null);
    }

    const addSlideBtn = async () => {
        try {
            const caption = addCaptionRef.current.value;

            toast.loading("Please wait...");
            const res = await addSliderData({ file: selectedFile, caption })
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                setImage(null)
                setSelectedFile(null)
                addCaptionRef.current.value = ''
                fetchTableData()
                document.getElementById("modal-addSlide").close()
            } else {
                toast.error(message);
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    // const editSlideBtn = async () => {
    //     try {
    //         const caption = editCaptionRef.current.value;

    //         toast.loading("Please wait...");
    //         const res = await editSliderData({ id: selectedRowId, file: selectedFile, caption })
    //         const message = res.data.message;
    //         toast.dismiss();
    //         if (res.status === 200) {
    //             toast.success(message);
    //             setImage(null)
    //             setSelectedFile(null)
    //             editCaptionRef.current.value = ''
    //             fetchTableData()
    //             document.getElementById("modal-editSlide").close()
    //         } else {
    //             toast.error(message);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         const message = error?.response?.data?.message || "Something went wrong!";
    //         toast.dismiss();
    //         toast.error(message);
    //     }
    // }
    const editSlideBtn = async () => {
        try {
            const caption = editCaptionRef.current.value.trim() || null; 
    
            toast.loading("Please wait...");
            const res = await editSliderData({ 
                id: selectedRowId, 
                file: selectedFile, 
                caption 
            });
    
            toast.dismiss();
            const message = res.data.message;
    
            if (res.status === 200) {
                toast.success(message);
                setImage(null);
                setSelectedFile(null);
                if (editCaptionRef.current) {
                    editCaptionRef.current.value = '';
                }
                fetchTableData();
                document.getElementById("modal-editSlide").close();
            } else {
                toast.error(message);
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    };
    

    const handlePriorityChange = async (id, newPriority) => {
        try {
            toast.loading("Updating priority...");
            const response = await updateSliderPriority({ id, order: newPriority });
            toast.dismiss();
            if (response.status === 200) {
                toast.success("Priority updated successfully!");
                setData((prevData) =>
                    prevData.map((item) =>
                        item.id === id ? { ...item, priority: newPriority } : item
                    )
                );
            } else {
                toast.error("Failed to update priority.");
            }
        } catch (error) {
            console.error("Error updating priority:", error);
            const message = error?.response?.data?.message || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    };
    

    const deleteSliderRow = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteSliderData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    console.log('selected file => ', selectedFile)

    return (

        <div>
            <div>
                <Page className="px-8 py-6">

                    <div className="p-6">

                        <div className='flex items-center gap-10 text-xl'>
                            <div className="text-[#4B465C] ">
                                Home page / <hi className="text-[black] bg-white mt-6"> Slider Management</hi>
                            </div>
                        </div>
                        <div className='flex items-center justify-between mt-2'>
                            <div > Add a New  Slide</div>

                            <div>
                                <Button isDisabled={data.length === 0 || data.length >= 5} onClick={() => document.getElementById("modal-addSlide").showModal()} >Add New Slider</Button>
                            </div>

                        </div>


                        <h1 className="text-xl font-bold mb-2 text-[#4B465C] mt-6">Website Hero Collection</h1>
                        <p className="mb-4 text-gray-600">A total of 5 images you can collect! (set  first priority to the  lowest sized image, image size should 1920x550 )</p>

                        <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                            <thead>
                                <tr className="bg-gray-100 text-[#4B465C]">
                                    <th className="w-1/4 px-4 py-2 text-center">Preview</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Caption</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Priority</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.id} className="border-b hover:bg-gray-50">

                                        <td className="px-4 py-2 text-center">
                                            <div className="w-16 h-16 mx-auto overflow-hidden bg-gray-200 rounded-md">
                                                <img
                                                    src={item.image} // Place image
                                                    alt={`Preview ${index + 1}`}
                                                    className="object-cover w-full h-full"
                                                />
                                            </div>
                                        </td>


                                        <td className="px-4 py-2 text-center">{item.caption}</td>


                                        <td className="px-4 py-2 text-center">
                                                <select
                                                    value={item.priority}
                                                    onChange={(e) => handlePriorityChange(item.id, e.target.value)}
                                                    className="px-2 py-1 border border-gray-300 rounded-md"
                                                >
                                                    {[1, 2, 3, 4, 5].map((priority) => (
                                                        <option key={priority} value={priority}>
                                                            {priority}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>



                                        <td className="px-4 py-2 text-center">
                                            <div className="flex justify-center gap-4">


                                                <button
                                                    onClick={() => {
                                                        setSelectedRowId(item.id)
                                                        document.getElementById("modal-delete").showModal();
                                                    }}
                                                    className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                >
                                                    Delete
                                                    <RiDeleteBin2Line className="ml-2" />
                                                </button>

                                                <button onClick={() => {
                                                    setSelectedRowId(item.id)
                                                    setImage(item.image)
                                                    editCaptionRef.current.value = item.caption
                                                    document.getElementById("modal-editSlide").showModal();
                                                }} className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                    Edit
                                                    <FiEdit />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Page>
            </div>

            <dialog
                id="modal-addSlide"
                className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle w-96"
            >
                <div className="w-full max-w-2xl p-6 mx-auto bg-white rounded-lg shadow-lg">

                    <div className="mb-6">
                        <h2 className="text-lg font-medium text-[#4B465C]">Add Slide Information</h2>
                    </div>

                    <div className="mb-4">
                        <label
                            htmlFor="caption"
                            className="block text-sm font-medium text-gray-700"
                        >
                            Main Caption Text
                        </label>
                        <input
                            ref={addCaptionRef}
                            type="text"
                            id="caption"
                            placeholder="Hero Title 1"
                            maxLength={100}
                            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-[#92288C] focus:border-[#92288C]"
                        />
                        <p className="mt-1 text-sm text-gray-500">Max 100 characters</p>
                    </div>


                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Image <span className="text-gray-400">(Accept: .jpg, .png, .webp)</span>
                        </label>
                        <div className="flex flex-col items-center justify-center mt-2 border-2 border-gray-300 border-dashed rounded-lg h-36" onDragOver={handleDragOver} onDrop={handleDrop}>
                            {/* {image ? (
                                <img
                                    src={image}
                                    alt="Uploaded Preview"
                                    className="object-contain w-auto h-28"
                                />
                            ) : (
                                <div className="text-gray-500">
                                    <div className="flex justify-center">
                                        <svg
                                            xmlns="image...."
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-10 h-10"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 4.5v15m7.5-7.5h-15"
                                            />
                                        </svg>
                                    </div>
                                    <p>Drag and drop image here</p>
                                    <p className="text-sm text-center text-gray-400">
                                    Maximum file size is 1MB
                        </p>
                                    <label className="text-[#92288C] cursor-pointer">
                                        <input
                                            type="file"
                                            accept=".jpg, .png,.webp"
                                            onChange={handleImageChange}
                                            className="hidden"
                                        />
                                        Browse image
                                    </label>
                                </div>
                            )} */}
                            {image ? (
                                <div className="relative">
                                    <img
                                        src={image}
                                        alt="Uploaded Preview"
                                        className="object-contain w-auto h-28"
                                    />
                                    <button
                                        onClick={removeImage}
                                        className="absolute top-0 right-0 p-1 text-red-500 bg-white rounded-full hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                            ) : (
                                <div className="text-gray-500">
                                    <div className="flex justify-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-10 h-10"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 4.5v15m7.5-7.5h-15"
                                            />
                                        </svg>
                                    </div>
                                    <p>Drag and drop image here</p>
                                    <p className="text-sm text-center text-gray-400">
                                        Maximum file size is 1MB
                                    </p>
                                </div>
                            )}
                            <label className="text-[#92288C] cursor-pointer">
                                <input
                                    type="file"
                                    accept=".jpg, .png,.webp"
                                    onChange={handleImageChange}
                                    className="hidden"
                                />
                                Browse image
                            </label>
                        </div>
                    </div>

                    {/* Footer Buttons */}
                    <div className="flex justify-between">
                        <button
                            className="px-4 py-2 text-gray-500 border border-gray-300 rounded-md"
                            onClick={() => document.getElementById("modal-addSlide").close()}
                        >
                            Back
                        </button>
                        <button
                            className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175]"
                            onClick={() => addSlideBtn()}
                        >
                            Add Slide
                        </button>
                    </div>
                </div>

            </dialog>

            <dialog
                id="modal-editSlide"
                // className="inset-0 z-50 flex items-center justify-center modal"
                className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle w-96"
            >
                <div className="w-full max-w-2xl p-6 mx-auto bg-white rounded-lg shadow-lg">

                    <div className="mb-6">
                        <h2 className="text-lg font-medium text-[#4B465C]">Edit Slide Information</h2>
                    </div>

                    <div className="mb-4">
                        <label
                            htmlFor="caption"
                            className="block text-sm font-medium text-gray-700"
                        >
                            Main Caption Text
                        </label>
                        <input
                            ref={editCaptionRef}
                            type="text"
                            id="caption"
                            placeholder="Hero Title 1"
                            maxLength={100}
                            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-[#92288C] focus:border-[#92288C]"
                        />
                        <p className="mt-1 text-sm text-gray-500">Max 100 characters</p>
                    </div>


                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Image <span className="text-gray-400">(Accept: .jpg, .png .webp)</span>
                        </label>
                        <div className="flex flex-col items-center justify-center mt-2 border-2 border-gray-300 border-dashed rounded-lg h-36" onDragOver={handleDragOver} onDrop={handleDrop}>
                            {/* {image ? (
                                <img
                                    src={image}
                                    alt="Uploaded Preview"
                                    className="object-contain w-auto h-28"
                                />
                            ) : (
                                <div className="text-gray-500">
                                    <div className="flex justify-center">
                                        <svg
                                            xmlns="image...."
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-10 h-10"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 4.5v15m7.5-7.5h-15"
                                            />
                                        </svg>
                                    </div>
                                    <p>Drag and drop image here</p>
                                    <p className="text-sm text-center text-gray-400">
                      Maximum file size is 1MB
                        </p>
                                    <label className="text-[#92288C] cursor-pointer">
                                        <input
                                            type="file"
                                            accept=".jpg, .png, .webp"
                                            onChange={handleImageChange}
                                            className="hidden"
                                        />
                                        Browse image
                                    </label>
                                </div>
                            )} */}
                            {image ? (
                                <div className="relative">
                                    <img
                                        src={image}
                                        alt="Uploaded Preview"
                                        className="object-contain w-auto h-28"
                                    />
                                    {/* <button
                                        onClick={removeImage}
                                        className="absolute top-0 right-0 p-1 text-red-500 bg-white rounded-full hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </button> */}
                                </div>
                            ) : (
                                <div className="text-gray-500">
                                    <div className="flex justify-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth={1.5}
                                            stroke="currentColor"
                                            className="w-10 h-10"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 4.5v15m7.5-7.5h-15"
                                            />
                                        </svg>
                                    </div>
                                    <p>Drag and drop image here</p>
                                    <p className="text-sm text-center text-gray-400">
                                        Maximum file size is 1MB
                                    </p>
                                </div>
                            )}
                            {/* {image && <button onClick={() => setImage(null)}>Remove Image</button>} */}
                            <label className="text-[#92288C] cursor-pointer">
                                <input
                                    type="file"
                                    accept=".jpg, .png,.webp"
                                    onChange={handleImageChange}
                                    className="hidden"
                                />
                                Browse image
                            </label>
                        </div>
                    </div>
                    <div className="flex justify-between">
                        <button
                            className="px-4 py-2 text-gray-500 border border-gray-300 rounded-md"
                            onClick={() => {
                                setSelectedRowId(null)
                                setImage(null)
                                editCaptionRef.current.value = ''
                                document.getElementById("modal-editSlide").close()
                            }}
                        >
                            Back
                        </button>
                        <button
                            className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#7a2175]"
                            onClick={() => editSlideBtn()}
                        >
                            Edit Slide
                        </button>
                    </div>
                </div>

            </dialog>

            <dialog
                id="modal-delete"
                className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
            >

                <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="font-bold text-gray-500">
                            Are you sure?
                        </p>
                    </div>


                    <div className="flex justify-center mt-4 space-x-4">
                        <button
                            onClick={() => {
                                setSelectedRowId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                        >
                            No
                        </button>
                        <button
                            onClick={async () => {
                                deleteSliderRow();
                            }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>

        </div>

    );
};

export default SliderManagement;

